import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FilterWithMapper from '../FilterWithMapper/FilterWithMapper';
import { currencyMapper } from '@nexio/emvio-util-app';
import { connect } from 'react-redux';
import { getMerchants } from '../../../Merchants/merchantsEntity';

export class CurrencyCodeFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        merchants: PropTypes.any,
        onChange: PropTypes.func,
        allowAllCurrencies: PropTypes.bool,
        shouldUseCurrencyCodeAsValue: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.mapper = this.createMapper(props.merchants, props.allowAllCurrencies);
    }

    createMapper(merchants, showAllCurrencies) {
        let currencyList = _.mapValues(currencyMapper, 'code');

        if (!showAllCurrencies && !_.isEmpty(merchants)) {
            const allowedCurrencies = _.map(merchants, 'currencyId');

            currencyList = _.pickBy(currencyList, (currency, currencyKey) => {
                return _.includes(allowedCurrencies, currencyKey);
            });
        }

        if (this.props.shouldUseCurrencyCodeAsValue) {
            currencyList = _.mapKeys(currencyList, (currencyCode) => currencyCode);
        }

        currencyList = _.toPairs(currencyList); // this transforms { key1: value1 } to [ [key1, value1] ]
        currencyList.sort((currencyPair1, currencyPair2) => {
            // makes sure USD is at the top
            if (currencyPair1[1] === 'usd') {
                return -1;
            } else if (currencyPair2[1] === 'usd') {
                return 1;
            }

            return currencyPair1[1] > currencyPair2[1] ? 1 : -1;
        });

        return currencyList;
    }

    render() {
        return (
            <FilterWithMapper onChange={this.props.onChange} filter={this.props.filter} mapper={this.mapper} />
        );
    }
}

function mapStateToProps(state) {
    return {
        merchants: getMerchants(state)
    };
}

export default connect(mapStateToProps)(CurrencyCodeFilter);
